import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * datetime: type → label → required → [Advanced: width, placeholder, prefillLastValue]
 */
export function getDateTimeFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      COMMON_FIELD_CONFIGS['placeholder'],
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
